<template>  
  <div class="gradient-background">
      <div ref="vantaEffect" class="vanta-container"></div>
  </div>
  
  
</template>  
  
<script>
import * as THREE from 'three'
import DOTS from 'vanta/src/vanta.dots'
import FOG from 'vanta/src/vanta.fog'

export default {   
  name: "VantaDots",
  data() {
    return {
      
    };
  },
  mounted() {
    // this.vantaEffect = VANTA.DOTS({
    //   el: this.$refs.vantaEffect,
    //   mouseControls: true,
    //   touchControls: true,
    //   gyroControls: false,
    //   minHeight: 200.00,
    //   minWidth: 200.00,
    //   scale: 1.00,
    //   scaleMobile: 1.00,
    //   color: 0x124889,
    //   color2: 0xffffff,
    //   backgroundColor: 0x0,
    //   size: 2.00,
    //   spacing: 27.00,
    //   showLines: false
    // })

    VANTA.FOG({
      el: this.$refs.vantaEffect,
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minHeight: 200.00,
      minWidth: 200.00,
      highlightColor: 0x121b3c,
      midtoneColor: 0x0,
      lowlightColor: 0x0,
      baseColor: 0x0,
      blurFactor: 0.62,
      speed: 2.90,
      zoom: 1.10
    })
  },
  beforeDestroy() {
    if (this.vantaEffect) {
      this.vantaEffect.destroy()
    }
  },
  methods: {
    
  },

};
</script>

<style lang="scss" scoped>  
.gradient-background {  
  position: relative;  
  width: 100%;  
  height: 100vh;  
  background-image: linear-gradient(180deg, #000000 0%, #141638 100%);  
  overflow: hidden;  

  .vanta-container {  
    position: absolute;  
    top: 0;  
    left: 0;  
    width: 100%;  
    height: 100%;  
    z-index: 1; /* 确保 VANTA 效果在渐变之上 */  
  }
}  
 

 
</style>